import CIMSSelect from '../..'
import { CommonSelect } from '../types'
import { useUserSelectContext } from './UserSelectContext'

/**
 * a {@link CIMSSelect} component for active project Users using complex values
 *
 * any initial values passed into this component should be complex values as well
 *
 * wrap any components using this component in the {@link UserSelectProvider}
 */
const UserSelect: React.FC<CommonSelect<'virtual'>> = (props) => {
  const { loading, options } = useUserSelectContext()
  return <CIMSSelect loading={loading} options={options} {...props} />
}

export default UserSelect
